var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391",
    transform: "translate(-1346.878 -34)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(1346.878 34)",
    fill: "#832ee6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(445.235 552.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M912.047-510.854c.145.066.289.135.436.2a8.3,8.3,0,0,1,4.759,5.266.228.228,0,0,1-.1.31c-.527.365-1.044.743-1.566,1.116-.044.032-.092.059-.157.1l-1.189-3.009-1.179.464.669,1.7c.193.491.38.985.583,1.471a.2.2,0,0,1-.085.293c-.176.117-.337.255-.509.377a4.747,4.747,0,0,0-1.585,1.667,1.319,1.319,0,0,1-.081-.112,9.548,9.548,0,0,1-.11-9.765.72.72,0,0,0,.031-.077Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1135.847-510.854a10.026,10.026,0,0,1,1.034,2.6,9.633,9.633,0,0,1-1.13,7.279.273.273,0,0,1-.038.043,5.318,5.318,0,0,0-.588-.758c-.478-.434-.989-.833-1.5-1.23a.256.256,0,0,1-.1-.359c.416-1.03.819-2.065,1.237-3.124l-1.178-.467-1.184,3a.916.916,0,0,1-.113-.058c-.545-.388-1.085-.782-1.635-1.162a.2.2,0,0,1-.084-.278,8.293,8.293,0,0,1,4.649-5.23l.549-.248Z",
    transform: "translate(-207.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M963.044-388.169l-.28-.972-1.218.341c.125.445.25.875.365,1.307a7.99,7.99,0,0,1,.276,1.125,1.991,1.991,0,0,1-1.873,2.218,2,2,0,0,1-2.1-2c0-.182,0-.363,0-.541l1.12-.183-.29-1.243a6.493,6.493,0,0,1-2.927,0l-.293,1.246,1.1.179a2.055,2.055,0,0,1-1.8,2.545A2,2,0,0,1,953-386.591c.178-.731.4-1.451.609-2.208l-1.211-.347-.278.95c-.053-.05-.094-.084-.129-.123-.345-.391-.7-.773-1.03-1.177a2.855,2.855,0,0,1,.451-4.1q1.813-1.4,3.673-2.744a2.511,2.511,0,0,1,.932-.306,7.4,7.4,0,0,1,3.758.162,1.37,1.37,0,0,1,.409.208q1.721,1.28,3.434,2.571a2.881,2.881,0,0,1,.463,4.367C963.748-388.957,963.409-388.581,963.044-388.169Zm-8.2-4.507H953.5v1.246h1.339Zm5.473,1.245h1.331v-1.245h-1.331Z",
    transform: "translate(-37.411 -107.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1043.353-172.173a2.725,2.725,0,0,1-2.307,1.283,2.614,2.614,0,0,1-2.3-1.283,3.314,3.314,0,0,0,2.283-1.306A3.352,3.352,0,0,0,1043.353-172.173Z",
    transform: "translate(-120.87 -318.316)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.cad082ebaae7993d9e4ea562095ad8a5.svg";
export { ForwardRef as ReactComponent };